import React from "react";
import _ from "underscore";
import { hideDialog, updateDialog } from "../../../actions/dialog";
import { getEntity, saveEntity } from "../../../actions/entities";
import { EntitiesStore } from "../../../stores/entities";
import M from "../../../strings";
import { discriminated } from "../../../utils/ajex";
import { isNotEmpty, isEmpty, getFileServerUrl } from "../../../framework/utils";
import { Form } from "../../components/forms";
import { PresentationNotesControl } from "../../components/presentationNotesControl";
import * as CustomUtils from "../../../utils/customUtils";
import { ACTION_TYPES } from "../../components/mobile/actions";

export default class SurveySlideshowDownloadDialog extends React.Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.discriminator = "entity_form_" + this.getEntity();
        this.state = {};
    }

    getEntity() {
        return "presentationConfiguration"
    }

    componentDidMount() {
        updateDialog({
            title: M("surveySlideshowDownloadDialogTitle"),
            leftHeaderActions: [
                    {
                        id: "close-mobile",
                        type: ACTION_TYPES.ICON,
                        icon: "close",
                        className: "hidden-sm-up",
                        onClick: hideDialog,
                    },
                    {
                        id: "close-tabled",
                        type: ACTION_TYPES.BUTTON,
                        text: M("cancel"),
                        className: "btn-transparent-secondary hidden-xs-down",
                        onClick: hideDialog,
                    },
                ],
            rightHeaderActions: [
                {
                    id: "generate",
                    type: ACTION_TYPES.BUTTON,
                    text: M("create"),
                    className: "btn-transparent-primary",
                    onClick: this.generateReport.bind(this),
                }
            ],
        });

        EntitiesStore.subscribe(this, state => {
            const presentationConfiguration = discriminated(state, this.discriminator);

            if (isNotEmpty(presentationConfiguration) && isNotEmpty(presentationConfiguration.data) && isEmpty(presentationConfiguration.data.survey)) {
                presentationConfiguration.data.survey = CustomUtils.deepClone(this.props.survey);
            }
            
            this.setState({
                presentationConfiguration: presentationConfiguration,
            }, this.forceUpdate.bind(this));
        });

        getEntity({
            discriminator: this.discriminator,
            entity: this.getEntity(),
            id: "new",
        });
    }

    componentWillUnmount() {
        EntitiesStore.unsubscribe(this);
    }

    getDownloadPath() {
        return this.state.presentationConfiguration?.data?.path ?? undefined;
    }

    getDescriptor() {
        return {
            showInCard: false,
            onModelLoadFirstTime: (model) => model.set("survey", this.props.survey),
            fields: [
                {
                    label: M("surveySlideshowDownloadNotesLabel"),
                    property: "presentationNotes",
                    control: PresentationNotesControl,
                    props: {
                        startsCollapsed: true,
                    }
                }
            ]
        }
    }

    generateReport() {
        const model = this.formRef.current.model,
            data = model.sanitized();

        saveEntity({
            discriminator: this.discriminator,
            entity: this.getEntity(),
            data: data,
            reload: true,
        }).then(() => updateDialog({
                leftHeaderActions: [
                    {
                        id: "close-mobile",
                        type: ACTION_TYPES.ICON,
                        icon: "close",
                        className: "hidden-sm-up",
                        onClick: hideDialog,
                    },
                    {
                        id: "close-tabled",
                        type: ACTION_TYPES.BUTTON,
                        text: M("close"),
                        className: "btn-transparent-secondary hidden-xs-down",
                        onClick: hideDialog,
                    },
                ],
                rightHeaderActions: [],
            })); 
    }

    downloadReport() {
        const path = this.getDownloadPath();
        if (isNotEmpty(path)) {
            window.open(getFileServerUrl(path));
        }
    }

    render() {
        const data = this.state.presentationConfiguration?.data ?? undefined,
            downloadPath = this.getDownloadPath(),
            descriptor = this.getDescriptor();

        return(
            <div>
                {isNotEmpty(data) && <>
                    {isEmpty(downloadPath) ? (<>
                        <Form
                            ref={this.formRef}
                            descriptor={descriptor}
                            data={data}
                        />
                    </>) : (<div
                        className="text-center m-5"
                    >
                        <div
                            className="mb-3"
                        >
                            {M("surveySlideshowDownloadSuccessMessate")}
                        </div>
                        <button
                            className="btn btn-primary font-weight-bold"
                            role="button"
                            onClick={this.downloadReport.bind(this)}
                        >
                            {M("download")}
                        </button>
                    </div>)}
                </>}
            </div>
        )
    }
}